import {Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {MessageImage} from '../../../core/models/message-image.model';

@Component({
    selector: 'cm-image-carousel',
    templateUrl: './image-carousel.component.html',
    styleUrls: ['./image-carousel.component.scss'],
    standalone: false
})
export class ImageCarouselComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  public images: MessageImage[] = [];

  @Input()
  public interval = 5000;

  public imagePathA = '';
  public imagePathB = '';
  public activeSlot: 'a' | 'b' = 'a';
  public resetA = false;
  public resetB = false;

  now: number;
  intervalId;
  private carouselIntervalId;
  private resetTimeoutId;
  private currentImageIndex = 0;

  private static readonly FADE_DURATION = 1500;

  constructor(private readonly el: ElementRef) { }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
    clearInterval(this.carouselIntervalId);
    clearTimeout(this.resetTimeoutId);
  }

  ngOnInit(): void {
    this.intervalId = setInterval(() => this.now = Date.now(), 1000);
    this.startCarousel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['images'] && !changes['images'].firstChange) {
      this.startCarousel();
    }
  }

  private startCarousel(): void {
    if (!this.images || this.images.length === 0) return;

    clearInterval(this.carouselIntervalId);
    clearTimeout(this.resetTimeoutId);
    this.currentImageIndex = 0;
    this.imagePathA = this.images[0].original_url;
    this.activeSlot = 'a';
    this.resetA = false;
    this.resetB = true;
    this.el.nativeElement.style.setProperty('--zoom-duration', (this.interval / 1000) + 's');

    if (this.images.length <= 1) return;

    this.carouselIntervalId = setInterval(() => {
      this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
      const nextUrl = this.images[this.currentImageIndex].original_url;

      if (this.activeSlot === 'a') {
        this.resetB = false;
        this.imagePathB = nextUrl;
        this.activeSlot = 'b';
        this.scheduleReset('a');
      } else {
        this.resetA = false;
        this.imagePathA = nextUrl;
        this.activeSlot = 'a';
        this.scheduleReset('b');
      }
    }, this.interval);
  }

  private scheduleReset(slot: 'a' | 'b'): void {
    clearTimeout(this.resetTimeoutId);
    this.resetTimeoutId = setTimeout(() => {
      if (slot === 'a') {
        this.resetA = true;
      } else {
        this.resetB = true;
      }
    }, ImageCarouselComponent.FADE_DURATION);
  }
}
